import { createStore } from "vuex"
import createPersistedState from "vuex-persistedstate"

export default createStore({
  state: {
    language: "RU",
    currency: "RUB",
    theme: "light",
    tradeSymbol: null,
    actives: [],
    multi_fiat_value: [],
    tgUserInfo: null,
    tgUserData: null,
    botId: null,
    verification: false,
    isAuthenticated: false,
    isAuthenticating: true,
    authError: null,
    balanceData: null,
  },
  getters: {
    getLanguage(state) {
      return state.language
    },
    getCurrency(state) {
      return state.currency
    },
    getTheme(state) {
      return state.theme
    },
    getTradeSymbol(state) {
      return state.tradeSymbol
    },
    getActives(state) {
      return state.actives
    },
    getTgUserInfo(state) {
      return state.tgUserInfo
    },
    getTgUserData: (state) => state.tgUserData,
    getBotId: (state) => state.botId,
    getMultiFiatValue: (state) => state.multi_fiat_value,
    getVerification: (state) => state.verification,
    getIsAuthenticated: (state) => state.isAuthenticated,
    getIsAuthenticating: (state) => state.isAuthenticating,
    getAuthError: (state) => state.authError,
    getBalanceData: (state) => state.balanceData,
  },
  mutations: {
    setLanguage(state, language) {
      state.language = language
    },
    setCurrency(state, currency) {
      state.currency = currency
    },
    setTheme(state, theme) {
      state.theme = theme
    },
    setTradeSymbol(state, tradeSymbol) {
      state.tradeSymbol = tradeSymbol
    },
    setActives(state, actives) {
      state.actives = actives
    },
    setTgUserInfo(state, tgUserInfo) {
      state.tgUserInfo = tgUserInfo
    },
    setTgUserData(state, userData) {
      state.tgUserData = userData
    },
    setBotId(state, botId) {
      state.botId = botId
    },
    setMultiFiatValue(state, data) {
      state.multi_fiat_value = data
    },
    setVerification(state, data) {
      state.verification = data
    },
    setAuthenticated(state, value) {
      state.isAuthenticated = value
    },
    setAuthenticating(state, value) {
      state.isAuthenticating = value
    },
    setAuthError(state, error) {
      state.authError = error
    },
    setBalanceData(state, data) {
      state.balanceData = data
    },
    clearAuth(state) {
      state.tgUserData = null
      state.botId = null
      state.balanceData = null
      state.isAuthenticated = false
      state.authError = null
    },
  },
  actions: {},
  modules: {},
  plugins: [
    createPersistedState({
      paths: [
        "language",
        "currency",
        "theme",
        "tradeSymbol",
        "actives",
        "multi_fiat_value",
        "tgUserInfo",
        "verification",
      ],
    }),
  ],
})
